import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, User, BookOpen, Calendar, LogOut } from 'lucide-react';

const navLinkStyle = {
  textDecoration: 'none',
  color: '#8B6914',
  fontWeight: 600,
  fontSize: '1.05rem',
  padding: '0.55rem 1.25rem',
  border: '2px solid #d4af37',
  borderRadius: '2rem',
  transition: 'all 0.2s ease',
  whiteSpace: 'nowrap'
};

const Header = ({ user, onLogout }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="header-nav" style={{ height: '70px' }}>
      <div className="container" style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        maxWidth: '100%',
        padding: '0 2rem',
        height: '100%'
      }}>
        {/* Desktop Navigation */}
        <nav style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '1.25rem',
          width: '100%',
          justifyContent: 'center'
        }}>
          <Link to="/" style={navLinkStyle} data-testid="nav-accueil">
            Accueil
          </Link>
          <Link to="/programs" style={navLinkStyle} data-testid="nav-formations">
            Nos Formations
          </Link>
          <Link to="/livret-1-asp" style={navLinkStyle} data-testid="nav-livret1">
            Livret 1 diplôme ASP
          </Link>
          <Link to="/oral-vae" style={navLinkStyle} data-testid="nav-oral-vae">
            Oral VAE
          </Link>
          <Link to="/veille-professionnelle" style={navLinkStyle} data-testid="nav-veille-pro">
            Veille Professionnelle
          </Link>
          <Link to="/booking" style={navLinkStyle} data-testid="nav-reserver">
            Mon appel découverte gratuit
          </Link>

          {user ? (
            <>
              {user.role === 'admin' ? (
                <Link to="/admin" style={{
                  ...navLinkStyle,
                  background: '#E75480',
                  borderColor: '#E75480',
                  color: 'white',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <User size={16} />
                  <span>Espace Blandine</span>
                </Link>
              ) : (
                <Link to="/dashboard" style={{
                  ...navLinkStyle,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  <User size={16} />
                  <span>Tableau de bord</span>
                </Link>
              )}
              <button onClick={onLogout} style={{
                ...navLinkStyle,
                background: 'transparent',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <LogOut size={16} />
                <span>Déconnexion</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/login" style={{
                ...navLinkStyle,
                background: 'white'
              }} data-testid="nav-connexion">
                Connexion
              </Link>
              <Link to="/register" style={{
                textDecoration: 'none',
                color: 'white',
                fontWeight: 700,
                fontSize: '1.2rem',
                padding: '0.75rem 2rem',
                border: '3px solid #d4af37',
                borderRadius: '2rem',
                background: 'linear-gradient(135deg, #E75480, #d63370)',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap',
                boxShadow: '0 4px 15px rgba(231, 84, 128, 0.3)'
              }} data-testid="nav-inscrire">
                S'INSCRIRE
              </Link>
            </>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          style={{
            display: 'none',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '0.5rem'
          }}
          className="mobile-menu-btn"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu" style={{
          position: 'absolute',
          top: '70px',
          left: 0,
          right: 0,
          background: 'rgba(255,255,255,0.97)',
          backdropFilter: 'blur(8px)',
          padding: '1.25rem',
          borderBottom: '2px solid #d4af37',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem',
          zIndex: 999
        }}>
          <Link to="/" onClick={() => setMobileMenuOpen(false)} style={{
            ...navLinkStyle,
            display: 'block',
            textAlign: 'center'
          }}>
            Accueil
          </Link>
          <Link to="/programs" onClick={() => setMobileMenuOpen(false)} style={{
            ...navLinkStyle,
            display: 'block',
            textAlign: 'center'
          }}>
            Nos Formations
          </Link>
          <Link to="/livret-1-asp" onClick={() => setMobileMenuOpen(false)} style={{
            ...navLinkStyle,
            display: 'block',
            textAlign: 'center'
          }}>
            Livret 1 diplôme ASP
          </Link>
          <Link to="/oral-vae" onClick={() => setMobileMenuOpen(false)} style={{
            ...navLinkStyle,
            display: 'block',
            textAlign: 'center'
          }}>
            Oral VAE
          </Link>
          <Link to="/veille-professionnelle" onClick={() => setMobileMenuOpen(false)} style={{
            ...navLinkStyle,
            display: 'block',
            textAlign: 'center'
          }}>
            Veille Professionnelle
          </Link>
          <Link to="/booking" onClick={() => setMobileMenuOpen(false)} style={{
            ...navLinkStyle,
            display: 'block',
            textAlign: 'center'
          }}>
            Mon appel découverte gratuit
          </Link>
          
          {user ? (
            <>
              {user.role === 'admin' ? (
                <>
                  <Link to="/admin" onClick={() => setMobileMenuOpen(false)} style={{
                    ...navLinkStyle,
                    background: '#E75480',
                    borderColor: '#E75480',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}>
                    <User size={16} />
                    <span>Espace Blandine</span>
                  </Link>
                  <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)} style={{
                    ...navLinkStyle,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.5rem'
                  }}>
                    <BookOpen size={16} />
                    <span>Voir les formations</span>
                  </Link>
                </>
              ) : (
                <Link to="/dashboard" onClick={() => setMobileMenuOpen(false)} style={{
                  ...navLinkStyle,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}>
                  <User size={16} />
                  <span>Tableau de bord</span>
                </Link>
              )}
              <button onClick={() => { onLogout(); setMobileMenuOpen(false); }} style={{
                ...navLinkStyle,
                background: 'transparent',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                width: '100%'
              }}>
                <LogOut size={16} />
                <span>Déconnexion</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setMobileMenuOpen(false)} style={{
                ...navLinkStyle,
                display: 'block',
                textAlign: 'center',
                background: 'white'
              }}>
                Connexion
              </Link>
              <Link to="/register" onClick={() => setMobileMenuOpen(false)} style={{
                textDecoration: 'none',
                color: 'white',
                fontWeight: 700,
                fontSize: '1.15rem',
                padding: '0.75rem 2rem',
                border: '3px solid #d4af37',
                borderRadius: '2rem',
                background: 'linear-gradient(135deg, #E75480, #d63370)',
                display: 'block',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(231, 84, 128, 0.3)'
              }}>
                S'INSCRIRE
              </Link>
            </>
          )}
        </div>
      )}

      <style jsx>{`
        @media (max-width: 768px) {
          nav {
            display: none !important;
          }
          .mobile-menu-btn {
            display: block !important;
          }
        }
        @media (min-width: 769px) {
          .mobile-menu {
            display: none !important;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;
